import { NgModule } from '@angular/core';
import { KrakenFooterComponent } from './kraken-footer.component';
import { CommonModule } from '@angular/common';


@NgModule({
  declarations: [
    KrakenFooterComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    KrakenFooterComponent
  ]
})
export class KrakenFooterModule { }
